import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import OrderList from "./OrderList";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import utils from "../../universal/utils";

const styles = (theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 33,
    marginLeft: "auto",
    marginRight: "auto",
  },
  headline: {
    fontSize: "14pt",
    fontWeight: 525,
  },
  para: {
    margin: "15px 8px",
  },
  "@media (min-width: 1024px)": {
    root: {
      marginTop: 80,
      width: 1000,
    },
  },
});

const hebrewLabels = {
  title: "ניהול הזמנות",
};

const basePath = utils.getEdgeBasePath();
class AdminPage extends React.Component {
  state = { isAuthenticated: false, user: null, token: "" };

  componentDidMount() {
    // Check for existing authentication in localStorage
    const savedToken = localStorage.getItem('admin_token');
    const savedUser = localStorage.getItem('admin_user');
    
    if (savedToken && savedUser) {
      try {
        const user = JSON.parse(savedUser);
        this.setState({ isAuthenticated: true, user, token: savedToken });
        this.props.actions.getOrders();
      } catch (error) {
        console.error('Error loading saved authentication:', error);
        // Clear invalid data
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
      }
    }
  }

  googleResponse = (credentialResponse) => {
    // The new library provides a credential (JWT token) instead of access token
    const tokenBlob = new Blob(
      [JSON.stringify({ credential: credentialResponse.credential }, null, 2)],
      { type: "application/json" }
    );
    const options = {
      method: "POST",
      body: tokenBlob,
      mode: "cors",
      cache: "default",
    };

    fetch(`${basePath}/auth/google`, options).then((r) => {
      const token = r.headers.get("x-auth-token");
      r.json().then((user) => {
        if (token) {
          this.setState({ isAuthenticated: true, user, token });
          // Persist authentication state
          localStorage.setItem('admin_token', token);
          localStorage.setItem('admin_user', JSON.stringify(user));
          this.props.actions.getOrders();
        }
      });
    }).catch((error) => {
      console.error('Authentication error:', error);
    });
  };

  googleErrorResponse = () => {
    console.error('Google authentication failed');
  };

  logout = () => {
    this.setState({ isAuthenticated: false, token: "", user: null });
    // Clear persisted authentication
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  };

  updateOrderStatus = (id, status) => {
    this.props.actions.updateStatusInflight();
    this.props.actions.updateOrderProps(id, { status });
  };

  onUpdateTrackingCode = (id, trackingCode) => {
    this.props.actions.updateStatusInflight();
    this.props.actions.updateOrderProps(id, { trackingCode });
  };

  onResendPurchaseEmails = (id) => {
    this.props.actions.updateStatusInflight();
    this.props.actions.resendPurchaseEmails(id);
  };

  getPaymentDetails = ({ orderId, token }) => {
    this.props.actions.getPaymentDetails({ orderId, token });
  };

  render() {
    const { classes, catalog } = this.props;
    const { orders, products, during } = catalog.admin;
    const { _id = "" } = this.state.user || {};

    const content = this.state.isAuthenticated ? (
      <div>
        {orders.length > 0 && (
          <OrderList
            during={during}
            orders={orders}
            products={products}
            token={_id}
            onGetPaymentDetails={this.getPaymentDetails}
            onUpdateStatus={this.updateOrderStatus}
            onUpdateTrackingCode={this.onUpdateTrackingCode}
            onResendPurchaseEmails={this.onResendPurchaseEmails}
          />
        )}
      </div>
    ) : (
      <div style={{ padding: 20, textAlign: 'center' }}>
        <Typography variant="body1" style={{ marginBottom: 20 }}>
          נדרשת הזדהות Google כדי לגשת למערכת הניהול
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={this.googleResponse}
            onError={this.googleErrorResponse}
            useOneTap
            auto_select
            theme="outline"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>
      </div>
    );

    // Wrap entire component with GoogleOAuthProvider at root level
    return (
      <GoogleOAuthProvider clientId="953186478491-6mps8iroc14e0h7sci1q2mh1q50dsqi6.apps.googleusercontent.com">
        <div>
          <Paper className={classes.root} elevation={4}>
            <Typography component="h1" variant="h1" className={classes.headline}>
              {hebrewLabels.title}
            </Typography>

            {content}
          </Paper>
        </div>
      </GoogleOAuthProvider>
    );
  }
}

AdminPage.propTypes = {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminPage);
